var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{on:{"click":_vm.openWindow}},[_vm._v("mdi-printer")])}
var staticRenderFns = []

export { render, staticRenderFns }